'use strict';

const processInclude = require('base/util');

processInclude(require('./product/updateProductAction'));
processInclude(require('app_custom_mufe_revamp/product/howToSection'));
processInclude(require('app_custom_mufe_revamp/components/alertOutOfStock'));
processInclude(require('app_custom_mufe_revamp/product/pdpPrimaryImages'));
processInclude(require('app_custom_mufe_revamp/product/pdpPrimaryGallery'));
processInclude(require('app_custom_mufe/product/detail'));
processInclude(require('app_custom_mufe_checkout/product/grProductDetails'));
processInclude(require('app_custom_mufe_revamp/product/showMoreShades'));
processInclude(require('app_custom_mufe_revamp/product/pdpTracking'));